import ReportingGroupPathDto from "./ReportingGroupPathDto";

export default class ReportingGroupDto {

    ReportingGroupId: number;
    Name: string;
    IsDefault: boolean;
    ReportingGroupPaths: ReportingGroupPathDto[];
    CustomerApiCredentialIds: number[];

    constructor(reportingGroupId: number, name: string, isDefault: boolean, reportingGroupPaths: ReportingGroupPathDto[], customerApiCredentialIds: number[]) {
        this.ReportingGroupId = reportingGroupId;
        this.Name = name;
        this.IsDefault = isDefault;
        this.ReportingGroupPaths = reportingGroupPaths;
        this.CustomerApiCredentialIds = customerApiCredentialIds;
    }
}
